module.exports = __webpack_public_path__ + "media/images/swifticons/mail-2b1aee149c92d0f18d3fa6d031f07390.svg";